/**
 * Validate Plugin
 */
(function(factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module depending on jQuery.
    define(["jquery"], factory);
  } else {
    // No AMD. Register plugin with global jQuery object.
    factory(window.jQuery || window.Zepto);
  }
})(function($) {
  // Plugin Constructor
  function Validator(element) {
    this.element = $(element);
    this.init();
  }
  // Plugin Object
  Validator.prototype = {
    init: function() {
      var fields = "input, textarea, select";
      //If we initialize with a form find all inputs
      this.inputs = this.element.find(fields);
      //Or Just use the current input
      if (this.element.is(fields)) {
        this.inputs = $().add(this.element);
      }
      this.scrErrors = $("#scr-errors");
      if (this.scrErrors.length === 0) {
        this.scrErrors = $(
          '<div id="scr-errors" role="alert" class="scr-only"><span id="message"></span></div>'
        ).appendTo("body");
      }
      this.tooltip = $("#validation-errors");
      if (this.tooltip.length === 0) {
        this.tooltip = $(
          '<div id="validation-errors" class="tooltip is-error is-clickable is-hidden right" role="tooltip" style="top: 78px; left: 54.2833px;"><div class="arrow"></div><div class="tooltip-content"><p></p></div></div>'
        ).appendTo("body");
      }
      this.timeout = null;
    },
    attachEvents: function() {
      var self = this,
        attribs = "[data-validate],[data-validation]",
        clickObj = null;
      $(document).on("mousedown.validate", function(e) {
        // The latest element clicked
        clickObj = $(e.target);
      });
      // when 'clickObj == null' on blur, we know it was not caused by a click
      // but maybe by pressing the tab key
      $(document).on("mouseup.validate", function() {
        clickObj = null;
      });
      //Attach required
      this.inputs.each(function() {
        var field = $(this),
          attr = field.attr("data-validate") || field.attr("data-validation");
        if (attr && attr.indexOf("required") > -1) {
          field.required();
        }
      });
      //Link on to the current object and perform validation.
      this.inputs
        .filter("input, textarea")
        .filter(attribs)
        .not("input[type=checkbox]")
        .on("blur.validate change.validate", function() {
          var field = $(this);
          if (
            $(this).css("visibility") === "is-hidden" ||
            !$(this).is(":visible")
          ) {
            return;
          }
          if (
            clickObj !== null &&
            (clickObj.is(".dropdown-option") ||
              clickObj.is(".inforTriggerButton") ||
              clickObj.closest(".modal").length === 1)
          ) {
            return;
          }
          setTimeout(function() {
            self.validate(
              field,
              field.closest(".modal-engaged") ? false : true
            );
          }, 200);
        });
      this.inputs
        .filter("input[type=checkbox]")
        .filter(attribs)
        .on("click.validate", function() {
          self.validate($(this), true);
        });
      this.inputs
        .filter("select")
        .filter(attribs)
        .on("change.validate", function() {
          self.validate($(this), true);
        });
      //Attach to Form Submit and Validate
      if (this.element.is("form")) {
        var submitHandler = function(e) {
          e.stopPropagation();
          e.preventDefault();
          self.validateForm(function(isValid) {
            self.element.off("submit.validate");
            self.element.trigger("validated", isValid);
            self.element.data("isValid", isValid);
            self.element.on("submit.validate", submitHandler);
          });
        };
        this.element.on("submit.validate", submitHandler);
      }
    },
    validateForm: function(callback) {
      var self = this,
        deferreds = [];
      self.inputs.each(function() {
        var dfds = self.validate($(this), false);
        for (var i = 0; i < dfds.length; i++) {
          deferreds.push(dfds[i]);
        }
      });
      $.when.apply($, deferreds).then(
        function() {
          callback(true);
        },
        function() {
          callback(false);
        }
      );
    },
    value: function(field) {
      if (field.is("input[type=checkbox]")) {
        return field.prop("checked");
      }
      return field.val();
    },
    getTypes: function(field) {
      if (
        field.is("input.dropdown") &&
        field
          .prev()
          .prev("select")
          .attr("data-validate")
      ) {
        return field
          .prev()
          .prev("select")
          .attr("data-validate")
          .split(" ");
      }
      if (
        field.is("input.dropdown") &&
        field
          .prev()
          .prev("select")
          .attr("data-validation")
      ) {
        return field
          .prev()
          .prev("select")
          .attr("data-validation")
          .split(" ");
      }
      if (field.attr("data-validation")) {
        return field.attr("data-validation").split(" ");
      }
      if (!field.attr("data-validate")) {
        return true;
      }
      return field.attr("data-validate").split(" ");
    },
    validate: function(field, showTooltip) {
      //call the validation function inline on the element
      var self = this,
        types = self.getTypes(field),
        rule,
        dfd,
        dfds = [],
        errors = [],
        i,
        value = self.value(field),
        manageResult = function(result) {
          if (!result) {
            self.addError(field, rule.message, showTooltip);
            errors.push(rule.msg);
            dfd.reject();
          } else if (errors.length === 0) {
            self.removeError(field);
            dfd.resolve();
          }
        };
      self.tabErrorCounts = {};
      self.removeError(field);
      field.removeData("data-errormessage");
      for (i = 0; i < types.length; i++) {
        rule = $.fn.validation.rules[types[i]];
        dfd = $.Deferred();
        if (!rule) {
          continue;
        }
        if (rule.async) {
          rule.check(value, manageResult, field);
        } else {
          manageResult(rule.check(value, field));
        }
        dfds.push(dfd);
      }
      return dfds;
    },
    getField: function(field) {
      if (field.parent().is(".inforTriggerField")) {
        field = field.parent();
      } else if (field.is(".inforListBox")) {
        field = field.next(".inforListBox");
      } else if (field.is(".inforSwapList")) {
        field = field.find(".inforSwapListRight div.inforListBox");
      } else if (field.is("select")) {
        var temp = field.next(".dropdown");
        if (temp.length == 0) {
          temp = field.next().next(".dropdown");
        }
        field = temp;
      }
      return field;
    },
    hasError: function(field) {
      return this.getField(field).hasClass("has-error");
    },
    setErrorIconOnTab: function(loc) {
      var tabPanel = $(loc).closest(".ui-tabs-panel");
      var id = "";
      var errorCount = 0;
      if (tabPanel && tabPanel.length > 0) {
        id = tabPanel.attr("id");
        id = "#" + id;
        errorCount = tabPanel.find(".has-error").length;
      }
      if (id) {
        // override position, margin-left, and margin-top on icon-error class
        var errorIcon =
          '<i style="position: static; margin-left:0px; margin-top:2px;" class="icon-error label noColon">&nbsp;</i>';
        var tab = $('a[href="' + id + '"]').parent();
        var isErrorIconOnTab = tab.children(".icon-error").length > 0;
        if (errorCount > 0) {
          if (!isErrorIconOnTab) {
            tab.append(errorIcon);
          }
        } else {
          tab.children(".icon-error").remove();
        }
      }
    },
    addError: function(field, message, showTooltip) {
      var loc = this.getField(field).addClass("has-error"),
        self = this,
        icon = $('<i class="icon-error">&nbsp;</i>'),
        appendedMsg =
          (loc.data("data-errormessage")
            ? loc.data("data-errormessage") + "<br>"
            : "") + message;
      self.loc = loc;
      loc.data("data-errormessage", appendedMsg);
      if (!loc.next().is(".icon-error") && !loc.is("input[type=checkbox]")) {
        if (
          loc
            .prop("tagName")
            .toLowerCase()
            .trim() === "textarea"
        ) {
          loc.wrap("<span></span>");
        }
        loc.after(icon);
        var isTextField =
          loc.hasClass("inforTextbox") || loc.hasClass("inforTextArea");
        if (isTextField) {
          loc.focusin(function() {
            if (
              $(this)
                .parent()
                .find(".icon-error").length > 0
            ) {
              var originalTextAlign = $(this).css("text-align");
              $(this).data().originalTextAlign = originalTextAlign;
              $(this).css("text-align", "left");
            } else {
              $(this).off("focusin");
            }
          });
          loc.focusout(function() {
            if (
              $(this)
                .parent()
                .find(".icon-error").length > 0
            ) {
              var originalTextAlign = $(this).data().originalTextAlign;
              if (!originalTextAlign || originalTextAlign.trim() === "") {
                originalTextAlign = "right";
              }
              $(this).css("text-align", originalTextAlign);
              $(this).data().originalTextAlign = originalTextAlign;
            } else {
              $(this).off("focusout");
            }
          });
        }
        if (
          loc
            .parent()
            .parent()
            .is("fieldset")
        ) {
          loc
            .parent()
            .parent()
            .find(".inforFieldSetLabel")
            .offset({ left: 7 });
          icon.offset({ left: 0 });
        }
        self.setErrorIconOnTab(loc);
      }
      if (
        !loc
          .next()
          .next()
          .is(".icon-error") &&
        loc.is("input[type=checkbox]")
      ) {
        loc.next(".inforCheckboxLabel").after(icon);
        self.setErrorIconOnTab(loc);
      }
      icon
        .on("mouseenter", function() {
          self.showTooltip(self.loc.data("data-errormessage"), self.loc);
        })
        .on("mouseleave", function() {
          self.tooltip.addClass("is-hidden");
        });
      if (showTooltip) {
        this.showTooltip(appendedMsg, field);
      }
      this.inputs.filter("input, textarea").on("focus.validate", function() {
        if (self.hasError(self.loc)) {
          self.showTooltip(self.loc.data("data-errormessage"), self.loc);
        }
      });
    },
    positionTooltip: function(field) {
      var leftPos = field.offset().left + field.width() + 22,
        topPos = field.offset().top - this.tooltip.height() / 2 + 10;
      if (field.is("input.dropdown")) {
        leftPos += 23; //the button area
      }
      if (field.parent().is(".inforTriggerField")) {
        leftPos += 3;
      }
      if (field.is("input[type=checkbox]")) {
        leftPos += field.next(".inforCheckboxLabel").width() + 5;
        topPos -= 14;
      }
      this.tooltip.css({ left: leftPos, top: topPos });
    },
    hideTooltip: function() {
      this.tooltip.addClass("is-hidden");
      $(document).off("scroll.validation");
      $(window).off("resize.validation");
      this.tooltip.off("click.validation");
    },
    showTooltip: function(message, field) {
      var self = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        if (!field.is(":visible")) {
          return;
        }
        //Add Aria Alert
        var messages = self.scrErrors.find("#message").attr("role", "alert");
        self.scrErrors.css("clip", "auto");
        messages.html(message);
        messages.hide().css("display", "inline");
        // HPS-97072 - Render the message in the tooltip to ensure correct tooltip height is calculated
        // before invoking positionTooltip() method 
        self.tooltip.find(".tooltip-content p").html(message);
        //Position
        self.positionTooltip(field);
        //then show tooltip
        self.tooltip
          .removeClass("is-hidden")
          .find(".tooltip-content p")
          .html(message);
        $(document).on("scroll.validation", function() {
          self.hideTooltip();
        });
        $(window).on("resize.validation", function() {
          self.hideTooltip();
        });
        self.tooltip.on("click.validation", function() {
          self.hideTooltip();
        });
      }, 350);
    },
    removeError: function(field) {
      var loc = this.getField(field),
        self = this;
      this.inputs.filter("input, textarea").off("focus.validate");
      loc.removeClass("has-error");
      loc.removeData("data-errormessage");
      self.setErrorIconOnTab(loc);
      loc.next(".icon-error").remove();
      loc
        .next(".inforCheckboxLabel")
        .next(".icon-error")
        .remove();
      loc.off("focusin");
      loc.off("focusout");
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        self.tooltip.addClass("is-hidden");
      }, 1);
    }
  };
  //Add a Message to a Field
  $.fn.addError = function(options) {
    var defaults = { message: "", showTooltip: false },
      settings = $.extend({}, defaults, options);
    return this.each(function() {
      var instance = new Validator(this, settings);
      instance.addError($(this), settings.message, settings.showTooltip);
    });
  };
  //Add a Message to a Field
  $.fn.removeError = function(options) {
    var defaults = { message: "", showTooltip: false },
      settings = $.extend({}, defaults, options);
    return this.each(function() {
      var instance = new Validator(this, settings);
      instance.removeError($(this));
    });
  };
  $.fn.validate = function(options, args) {
    // Settings and Options
    var pluginName = "validate",
      defaults = {},
      settings = $.extend({}, defaults, options);
    // Initializing the Control Once or Call Methods.
    return this.each(function() {
      var instance = $.data(this, pluginName);
      if (instance) {
        if (typeof instance[options] === "function") {
          instance[options](args);
        }
        instance.settings = $.extend({}, defaults, options);
      } else {
        instance = $.data(this, pluginName, new Validator(this, settings));
        instance.attachEvents();
      }
    });
  };
  //The validation rules object
  var Validation = function() {
    this.rules = {
      required: {
        check: function(value) {
          if (typeof value === "string" && $.trim(value).length === 0) {
            return false;
          }
          return value ? true : false;
        },
        message: Globalize.localize("Required")
      }
    };
  };
  //TODO: We will extend this with other settings like accessibility.
  //$.fn.settings = {};
  $.fn.validation = new Validation();
  //Migrate
  $.fn.validationMessage = function(showHide, message, showTooltip) {
    var field = $(this);
    if (showHide === "show") {
      field.removeError();
      field.addError({
        message: message,
        showTooltip: showTooltip ? true : false
      });
    } else {
      field.removeError();
    }
  };
  $.fn.setupValidation = function(callback) {
    $(this)
      .validate()
      .on("validated", function(e, isValid) {
        callback(isValid);
      });
  };
  $.Validation = {
    addRule: function(ruleId, rule, async) {
      if (rule.msg) {
        rule.message = rule.msg;
      }
      rule.async = async ? true : false;
      $.fn.validation.rules[ruleId] = rule;
    }
  };
  $.fn.isValid = function() {
    return $(this).data("isValid") ? true : false;
  };
  //Clear out the stuff on the Form
  $.fn.resetForm = function() {
    var formFields = $(this).find("input, select, textarea");
    //Clear Errors
    formFields.removeClass("has-error");
    $(this)
      .find(".has-error")
      .removeClass("has-error");
    $(this)
      .find(".icon-error")
      .remove();
    setTimeout(function() {
      $("#validation-errors").addClass("is-hidden");
    }, 300);
    //Remove Dirty
    formFields.data("isDirty", false).removeClass("isDirty");
    $(this)
      .find(".isDirty")
      .removeClass("isDirty");
    //reset form data
    if ($(this).is("form")) {
      $(this)[0].reset();
    }
  };
});
